import type { IconProps } from '../types/IconProps.ts';
export const CalendarClock: IconProps = {
    name: 'CalendarClock',
    children: [
        `<path d="M21 8V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h4M8 2v4M16 2v4M3 10h8" />`,
        `<circle cx="17" cy="17" r="5" />`,
        `<path d="M17 15v2.51l1.5.99" />`,
    ]
};